module.exports = __webpack_public_path__ + "static/media/about_01.ddd4eb62.png";